import styled from 'styled-components'

// Note: each row carries its own top spacing inside its Collapse (a parent flex gap would stay
// visible around a collapsed row), so the container cancels the parent's gap above the first row
export const Rows = styled.div(({ theme }) => ({
  marginTop: `calc(-1 * ${theme.space['8']})`,
}))

export const Row = styled.div(({ theme }) => ({
  paddingTop: theme.space['8'],
}))
